import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Icon, Label, List, Message, Segment } from "semantic-ui-react";
import styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/medical/";

const CommunityServicesLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0, 1]);

  const renderAccordionPlans = () => {
    return (
      <>      
       <Segment raised className={styles.segmentWhiteBG} > 
      <List divided relaxed bulleted className={styles.learnMoreBulletedList}  >
          <>
            <List.Item header="Area Agencies on Aging" 
              description="All places in the U.S. are covered by an Area Agency on Aging.  An area agency on aging (AAA) is a public or private nonprofit agency designated by a state to address the needs and concerns of all older persons at the regional and local levels." content={"The primary function of AAAs is to coordinate and offer services that help older people remain in their homes.   Their services  may include transportation, home-delivered meals, homemaker assistance, and others to help older adults live independently. AAAs typically compile print and/or online resource guides for older adults, specific to the areas they serve.  These guides list all services that may be helpful to older adults. Your local AAA should be your first point of contact to identify programs and agencies that can help maintain your older adult’s good health."}/>
            <List.Item header="Technological Sources of Help" 
              description="Increasingly, Americans are using technology to obtain health information and even to consult personally with health care professionals. The websites available through AgeReady are among these resources, and excellent information is also available through some YouTube presentations.  Some health care providers provide services through TeleHealth, reducing the need for older adults to travel to providers’ offices.  Older adults can also join health prevention classes or exercise sessions via their computers or televisions.  Resources such as these are particularly helpful for elders with limited mobility or who live in isolated areas. " />
          </>
        </List>
    </Segment>  
      </>
    );
  };


  const accordions = [
    { key: 'plans',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > What Does a Professional Driving Assessment Entail? </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionPlans()}/>)
      }
    }
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}EvalDrivingLearnMore2.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} exclusive={false}
                    className={styles.learnMoreModalAccordionGroup}
                    defaultActiveIndex={activeAccordionIndexes} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(CommunityServicesLearnMore);